<h2 mat-dialog-title>{{ data.title | translate }}</h2>
<mat-dialog-content class="mat-typography">
<form class="form-wrapper" [formGroup]="newPassswortForm" autocomplete=off>
  <div class="eineLinie">
    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.login.newPasswortDialog.altesPasswort' | translate }}</mat-label>
      <input
        matInput
        [type]="bHideOldPassword ? 'password' : 'text'"
        [placeholder]="'pages.login.newPasswortDialog.altesPasswort' | translate"
        formControlName="altesPasswort"
      />
      <mat-icon matSuffix (click)="bHideOldPassword = !bHideOldPassword">{{bHideOldPassword ? 'visibility_off' : 'visibility'}}</mat-icon>
      <mat-error *ngIf="newPassswortForm.controls.altesPasswort.invalid">{{ getErrorMessage('altesPasswort') | translate }}</mat-error>
    </mat-form-field>
    <div *ngIf="showHint">
    <p class="errorMessage">Altes Passwort ist nicht korrekt oder das Neue wurde nicht korrekt wiederholt.</p>
    </div>
  </div>
  <div class="eineLinie">
    <div>
      <mat-form-field appearance="outline" color="accent">
        <mat-label>{{ 'pages.login.newPasswortDialog.neuesPasswort1' | translate }}</mat-label>
        <input
          matInput
          [placeholder]="'pages.login.newPasswortDialog.neuesPasswort1' | translate"
          formControlName="neuesPasswort1"
          [(ngModel)]="account.pw"
          (input)="checkPw(account.pw)"
          [type]="bHideNewPasswordOne ? 'password' : 'text'"
        />
        <mat-icon matSuffix (click)="bHideNewPasswordOne = !bHideNewPasswordOne">{{bHideNewPasswordOne ? 'visibility_off' : 'visibility'}}</mat-icon>
        <mat-error *ngIf="newPassswortForm.controls.neuesPasswort1.invalid">{{ getErrorMessage('neuesPasswort1') | translate }}</mat-error>
      </mat-form-field>
      <div id="strength">
        <small style="margin-left:15px; font-size: 14px;">{{barLabel}}</small>
        <ul id="strengthBar">
          <li class="point" [style.background-color]="bar0"></li><li class="point" [style.background-color]="bar1"></li><li class="point" [style.background-color]="bar2"></li><li class="point" [style.background-color]="bar3"></li><li class="point" [style.background-color]="bar4"></li>
        </ul>
      </div>
    </div>

    <mat-form-field appearance="outline" color="accent">
      <mat-label>{{ 'pages.login.newPasswortDialog.neuesPasswort2' | translate }}</mat-label>
      <input
        matInput
        [placeholder]="'pages.login.newPasswortDialog.neuesPasswort2' | translate"
        formControlName="neuesPasswort2"
        [type]="bHideNewPasswordTwo ? 'password' : 'text'"
      />
      <mat-icon matSuffix (click)="bHideNewPasswordTwo = !bHideNewPasswordTwo">{{bHideNewPasswordTwo ? 'visibility_off' : 'visibility'}}</mat-icon>
      <mat-error *ngIf="newPassswortForm.controls.neuesPasswort2.invalid">{{ getErrorMessage('neuesPasswort2') | translate }}</mat-error>
    </mat-form-field>
  </div>
</form>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    id="abbruch"
    color="accent"
    (click)="noHandleClick()"
  >
    {{ data.cancelButtonLabel | translate }}
  </button>
  <button
    [disableRipple]="true"
    mat-raised-button
    color="accent"
    (click)="changePasswort()"
    [disabled]="newPassswortForm.invalid || this.scorePW < 70"
  >
    {{ data.submitButtonLabel | translate }}
  </button>
</mat-dialog-actions>
